module.exports = __webpack_public_path__ + "img/2.60e19e4b.png";